import dayjs from 'dayjs';

import { OptionType } from '@evinced-private/ui-common';

import { timeOptions } from '../../../helpers/SchedulingHelper';
import { IScheduledJobConfiguration } from '../../../interfaces/ScheduledJobConfiguration';

export const getRoundedUpTime = (): OptionType => {
	const now = dayjs();
	let hours = now.hour();
	const minutes = now.minute();

	if (minutes > 30) {
		hours = (hours + 1) % 24;
		return timeOptions.find((opt) => opt.value === `${hours}:00`) || timeOptions[0];
	}
	if (minutes > 0) {
		return timeOptions.find((opt) => opt.value === `${hours}:30`) || timeOptions[0];
	}
	return timeOptions.find((opt) => opt.value === `${hours}:00`) || timeOptions[0];
};

export const getSelectedTime = (
	config: Pick<IScheduledJobConfiguration, 'hours' | 'minutes'> | undefined
): OptionType[] => {
	if (config?.hours?.[0] !== undefined && config?.minutes?.[0] !== undefined) {
		const hours = config.hours[0];
		const minutes = config.minutes[0];
		const timeStr = `${hours}:${String(minutes).padStart(2, '0')}`;
		const timeOption = timeOptions.find((opt) => opt.value === timeStr) || timeOptions[0];
		return [timeOption];
	}
	return undefined;
};
